import type { LegendPayload } from 'recharts';
import { style } from './chart-legend.module.css';

interface Props {
  payload?: LegendPayload[];
}

export function ChartLegend(props: Props) {

  const { payload } = props;

  if (!payload || payload.length === 0) {
    return null;
  }

  return (
    <div className={style.container}>
      {payload.map((entry, index) => (
        <div key={index} className={style.item}>
          <div 
            className={style.dot} 
            style={{ backgroundColor: entry.color }}/>
          <span className={style.label}>{entry.value}</span>
        </div>
      ))}
    </div>
  );
}
